export default __webpack_public_path__ + "static/media/hangot-screenshot-03.418b06c6.png";